var _path;
function _extends() { return _extends = Object.assign ? Object.assign.bind() : function (n) { for (var e = 1; e < arguments.length; e++) { var t = arguments[e]; for (var r in t) ({}).hasOwnProperty.call(t, r) && (n[r] = t[r]); } return n; }, _extends.apply(null, arguments); }
import * as React from "react";
import { forwardRef } from "react";
const SvgAi = (props, ref) => /*#__PURE__*/React.createElement("svg", _extends({
  xmlns: "http://www.w3.org/2000/svg",
  fill: "currentcolor",
  viewBox: "0 0 16 16",
  ref: ref
}, props), _path || (_path = /*#__PURE__*/React.createElement("path", {
  fillRule: "evenodd",
  d: "M4.144 1.488c-.042-.143-.245-.143-.287 0l-.517 1.75a.15.15 0 0 1-.101.102l-1.75.516c-.144.042-.144.246 0 .288l1.75.516a.15.15 0 0 1 .101.101l.517 1.751c.042.143.245.143.287 0l.516-1.75a.15.15 0 0 1 .102-.102l1.75-.516c.144-.042.144-.246 0-.288l-1.75-.516a.15.15 0 0 1-.102-.101l-.516-1.751Zm5.098 2.409c-.067-.247-.417-.247-.483 0l-.994 3.691a.25.25 0 0 1-.176.177l-3.692.994c-.247.066-.247.416 0 .482l3.692.994a.25.25 0 0 1 .176.177l.994 3.691c.066.247.416.247.483 0l.994-3.691a.25.25 0 0 1 .176-.177l3.692-.994c.246-.066.246-.416 0-.482l-3.692-.994a.25.25 0 0 1-.176-.177l-.994-3.691Z",
  clipRule: "evenodd"
})));
const ForwardRef = /*#__PURE__*/forwardRef(SvgAi);
export default ForwardRef;